import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { AngularTokenService } from 'angular-token';
import { FormBuilder, Validators, FormArray, FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OnboardingService } from '../onboarding.service';
import { LoaderService } from '../../utils/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { SheetMetalComponent } from '../machine-popups/sheet-metal/sheet-metal.component';
import { OtherMachinesComponent } from '../machine-popups/other-machines/other-machines.component';
import { NewPrintProcessComponent } from '../machine-popups/new-print-process/new-print-process.component';
import { NewIndustryComponent } from '../machine-popups/new-industry/new-industry.component';
import { NewCertificatesComponent } from '../machine-popups/new-certificates/new-certificates.component';
import { NewPostProcessComponent } from '../machine-popups/new-post-process/new-post-process.component';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { EditMachineDetailsComponent } from '../machine-popups/edit-machine-details/edit-machine-details.component';

declare var $: any;

@Component({
  selector: 'app-machine-details',
  templateUrl: './machine-details.component.html',
  styleUrls: ['./machine-details.component.scss']
})
export class MachineDetailsComponent implements OnInit {

  capabilityDetailsForm: FormGroup;
  capabilities: any;
  keyword: any;
  keywordMachine: any;
  capabilityDetailsFormSubmitted = false;

  vendorSoftwares: any;
  showNewVendorSoftwareInput = false;

  vendorPostProcesses: any;
  showNewVendorPostProcessInput = false;

  manufacturingTechnologies: any;
  selectedManufacturingTechnology; any;
  selectedMachine: any;
  availableAddresses: any;
  availableAddressDropdownSettings = {};

  certificationFiles: any;

  vendorDesigns: any;
  selectedVendorDesigns: any;
  vendorDesignDropdownSettings = {};

  printProcesses: any;
  selectedPrintProcesses: any;
  printProcessDropdownSettings = {};
  newPrintProcessForm: FormGroup;
  isPrintProcessAdded = false;

  vendorPostProcessSettings = {};
  selectedPostProcesses: any;

  machineForm: FormGroup;
  machines: any;
  machineDetailsArray: any;
  brands: any;
  masterSpecs: any;
  machineUnits: any;
  machineFormSubmitted = false;
  editMachineIndex: any;

  vendorIndustries: any;
  selectedVendorIndustries: any;
  industryDropdownSettings = {};
  newIndustryForm: FormGroup;
  isNewIndustryAdded = false;

  certificates: any;
  selectedCertificates: any;
  certificatesDropdownSettings = {};
  newCertificateForm: FormGroup;
  isNewCertificateAdded = false;

  instruments: any;
  documents: any;

  vomSpecArray: any;

  measuring_instrument_table: boolean = true;

  machine_form_status: boolean;

  // detect the click event for the document:this
  document_click;

  private filesControl = new FormControl(null, FileUploadValidators.filesLimit(6));
  public demoForm = new FormGroup({
    files: this.filesControl
  });

  constructor(
    public onboardingService: OnboardingService,
    private toastr: ToastrService,
    private loaderService: LoaderService,
    public router: Router,
    public route: ActivatedRoute,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private elementRef: ElementRef
  ) {
    if (localStorage.getItem('has_onboarded') == "true") {
      this.router.navigate(['/onboarding/submitted']);
    }

  }

  loadedDetails = [];

  ngOnInit() {
    this.loadedDetails = [];
    this.keyword = "name";
    this.keywordMachine = "display_name"
    this.machineDetailsArray = [];
    this.vomSpecArray = [];
    this.certificationFiles = [];
    this.loaderService.display(true);

    this.capabilityDetailsForm = this.fb.group({
      'new_print_processes': "",
      'new_certificates': "",
      'no_of_machines': ["0", Validators.required],
      'selectedVendorIndustries': [],
      'selectedPrintProcesses': [],
      'selectedCertificates': [],
      'selectedPostProcesses': [],
      'vendor_designs_attributes': this.fb.array([]),
      'vendor_print_processes_attributes': this.fb.array([]),
      'vendor_industries_clients_attributes': this.fb.array([]),
      'vendor_certifications_attributes': this.fb.array([]),
      'vendor_owned_machines_attributes': this.fb.array([]),
      'vendor_works_attributes': this.fb.array([]),
      'new_vendor_softwares': "",
      'vendor_softwares_attributes': this.fb.array([]),
      'new_post_processes': "",
      'vendor_post_processes_attributes': this.fb.array([]),
      'quality_inspection_department': [false, Validators.required],
      // 'no_of_quality_instruments': [ "", Validators.required ],
      'vendor_quality_instruments_attributes': this.fb.array([]),
    });

    this.vendorDesignDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'display_name',
      allowSearchFilter: true,
      enableCheckAll: false,
    };

    this.onboardingService.getDesigns().subscribe(
      res => {
        this.vendorDesigns = res;
        this.selectedVendorDesigns = [];
        this.vendorDesigns.map(function (object) {
          object.is_checked = false;
        });
        this.loadedDetails.push("Got Designs");
        this.setCapabilityDetailsForm();
      }, err => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
        this.loadedDetails.push("Got Designs");
        this.setCapabilityDetailsForm();
      }
    );

    this.onboardingService.getAvailableAddresses().subscribe(
      res => {
        this.availableAddresses = res;
        this.loadedDetails.push("Got Available Addresses");
        this.setCapabilityDetailsForm();
      }, err => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
        this.loadedDetails.push("Got Available Addresses");
        this.setCapabilityDetailsForm();
      }
    );

    this.onboardingService.getManufacturingTechnologies().subscribe(
      res => {
        this.manufacturingTechnologies = res;
        this.loadedDetails.push("Got Manugacturing Technologies");
        this.setCapabilityDetailsForm();
      }, err => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
        this.loadedDetails.push("Got Manugacturing Technologies");
        this.setCapabilityDetailsForm();
      }
    );

    this.availableAddressDropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'name',
      allowSearchFilter: true,
      enableCheckAll: false,
    }

    this.newPrintProcessForm = this.fb.group({
      'new_print_process_name': ["", Validators.required],
    });

    this.printProcessDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'display_name',
      allowSearchFilter: true,
      enableCheckAll: false,
      searchPlaceholderText: 'Search here',
      maxHeight: '192'
    };

    this.vendorPostProcessSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'display_name',
      allowSearchFilter: true,
      enableCheckAll: false,
      searchPlaceholderText: 'Search here',
      maxHeight: '192'
    }

    this.onboardingService.getPrintProcesses().subscribe(
      res => {
        this.printProcesses = res;
        this.selectedPrintProcesses = [];
        this.loadedDetails.push("Got Print Processes");
        this.setCapabilityDetailsForm();
      }, err => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
        this.loadedDetails.push("Got Print Processes");
        this.setCapabilityDetailsForm();
      }
    );

    this.setMachineFields();
    this.selectedMachine = { id: "0", name: "others", display_name: "Others" }

    this.onboardingService.getVendorOwnedMachines().subscribe(
      res => {
        this.machineDetailsArray = res;
        this.vomSpecArray = this.machineDetailsArray.vom_specifications;
        this.loadedDetails.push("Got Vendor Owned Machines");
        this.setCapabilityDetailsForm();
      }, err => {
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
        this.loadedDetails.push("Got Vendor Owned Machines");
        this.setCapabilityDetailsForm();
      }
    );

    this.newIndustryForm = this.fb.group({
      'new_industry_name': ["", Validators.required],
    });

    this.industryDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'display_name',
      allowSearchFilter: true,
      enableCheckAll: false,
    };

    this.onboardingService.getIndustries().subscribe(
      res => {
        this.vendorIndustries = res;
        this.selectedVendorIndustries = [];
        this.loadedDetails.push("Got Industries");
        this.setCapabilityDetailsForm();
      }, err => {
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
        this.loadedDetails.push("Got Industries");
        this.setCapabilityDetailsForm();
      }
    );

    this.newCertificateForm = this.fb.group({
      'new_certificate_name': ["", Validators.required],
    });

    this.certificatesDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'display_name',
      allowSearchFilter: true,
      enableCheckAll: false,
    };

    this.onboardingService.getCertificates().subscribe(
      res => {
        this.certificates = res;
        this.selectedCertificates = [];
        this.loadedDetails.push("Got Certificates");
        this.setCapabilityDetailsForm();
      }, err => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
        this.loadedDetails.push("Got Certificates");
        this.setCapabilityDetailsForm();
      }
    );

    this.onboardingService.getSoftwares().subscribe(
      res => {
        this.vendorSoftwares = res;
        //this.vendorSoftwares.push({ "id": 0, "name": "others", "display_name": "Others" });

        this.vendorSoftwares.map(function (object) {
          object.is_checked = false;
        });
        this.loadedDetails.push("Got Softwares");
        this.setCapabilityDetailsForm();
      }, err => {
        if (err.error) {
          for (let i in err.error.errors) {
            this.toastr.error(err.error.errors[i]);
          }
        }
        this.loadedDetails.push("Got Softwares");
        this.setCapabilityDetailsForm();
      }
    );

    this.onboardingService.getPostProcesses().subscribe(
      res => {
        this.vendorPostProcesses = res;
        // this.vendorPostProcesses.push({ "id": 0, "name": "others", "display_name": "Others" });
        this.selectedPostProcesses = [];
        this.vendorPostProcesses.map(function (object) {
          object.is_checked = false;
        });
        this.loadedDetails.push("Got Post Processes");
        this.setCapabilityDetailsForm();
      }, err => {
        if (err.error) {
          for (let i in err.error.errors) {
            this.toastr.error(err.error.errors[i]);
          }
        }
        this.loadedDetails.push("Got Post Processes");
        this.setCapabilityDetailsForm();
      }
    );

    this.setCapabilityDetailsForm();
    if (this.machineDetailsArray.length == 0) {
      this.toastr.info('Please add atleast 1 machine to proceed further', 'info');
    }
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  // machinePopUp

  selectMachineTechnology(value) {
    let machine_index = this.manufacturingTechnologies.findIndex(element => element.name === value)
    let event = this.manufacturingTechnologies[machine_index]

    const dialogRef = this.dialog.open(SheetMetalComponent, {
      panelClass: 'my-panel',
      disableClose: true,
      data: { data: event }
    });

    dialogRef.afterClosed().subscribe(
      (res: any) => {
        let machine_details_data = res.data
        // console.log(machine_details_data)
        for (var i = 0; i < machine_details_data.length; i++) {
          this.machineDetailsArray.push(machine_details_data[i])
        }
        // if (this.machineDetailsArray.length == 0) {
        //   for (var i = 0; i < machineList.length; i++) {
        //     this.machineDetailsArray.push(machineList[i])
        //   }
        // }
        // else if(this.machineDetailsArray.length > 0){

        // }

        // else {
        //   this.machineDetailsArray = machineList
        // }
        console.log(this.machineDetailsArray)
        this.toastr.success('Machine Details Added Successfully', 'Success');

      }
    );

  }


  editFromMachineArray(item, index) {
    const dialogRef = this.dialog.open(EditMachineDetailsComponent, {
      panelClass: 'my-panel',
      disableClose: true,
      data: { data: index, machine_spec: item }
    });

    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res.message == 'success') {
          this.toastr.success('Machine details updated successfully', 'Success');
        }
        else if (res.message == 'failed') {
          this.toastr.info('No changes were made to the machine details', 'info');
        }
        console.log(res)
        let machineList = res.data
        let edited_machine_index = res.edited_machine_index
        this.machineDetailsArray[index] = machineList[edited_machine_index]
        console.log(this.machineDetailsArray)

      }
    );
  }

  // otherMachinesTechnology(event) {
  //   console.log(event)
  //   const dialogRef = this.dialog.open(OtherMachinesComponent, {
  //     panelClass: 'my-panel',
  //     disableClose: true,
  //     data: { data: event }
  //   });
  // }


  get f() { return this.capabilityDetailsForm.controls; }
  get mf() { return this.machineForm.controls; }

  setCapabilityDetailsForm() {
    if (this.loadedDetails.length > 8) {
      console.log('loadedDetails', this.loadedDetails);
      this.onboardingService.getCapabilityDetails().subscribe(
        (res: any) => {
          this.capabilities = res['form_data'];
          this.machine_form_status = res.form_status;
          let self = this;
          let selectedPrintProcessResponse = [];
          let selectedPostProcessResponse = [];
  
          let selectedVendorIndustryResponse = []
          let selectedcertificationResponse = [];
  
          let selectedSoftwareIds = [];
          let vendorSoftwares = this.vendorSoftwares || [];
  
          let selectedDesignIds = [];
          let vendorDesigns = this.vendorDesigns || [];
  
          let selectedPostProcessIds = [];
          let vendorPostProcesses = this.vendorPostProcesses || [];
  
          // setup vendor documents
          if (this.capabilities.documents.length != 0) {
            this.documents = this.capabilities.documents;
          }
  
          // setup vendor design value
          if (this.capabilities.designs.length != 0) {
            this.capabilities.designs.map(function (object) {
              self.setValueVendorDesign(object);
              selectedDesignIds.push(object.id)
            })
          }
  
          vendorDesigns.map(function (object) {
            if (selectedDesignIds.includes(object.id)) {
              object.is_checked = true;
            }
          });
  
          // setup print process value
          this.capabilities.print_processes.map(function (object) {
            self.setValuePrintProcess(object)
            console.log(object)
  
            selectedPrintProcessResponse.push({ id: object.id, display_name: object.name });
          });
  
          this.selectedPrintProcesses = selectedPrintProcessResponse;
          this.capabilityDetailsForm.controls['selectedPrintProcesses'].setValue(this.selectedPrintProcesses)
          this.selectedPrintProcesses.forEach(element => {
            this.onPrintProcessSelect(element)
            console.log(element)
          });
  
          if (res.no_of_machines) {
            this.capabilityDetailsForm.controls['no_of_machines'].setValue(res.no_of_machines)
          }
  
          // setup post process value
          this.capabilities.post_processes.map(function (object) {
            self.setValuePostProcess(object)
            selectedPostProcessResponse.push({ id: object.id, display_name: object.name })
          });
          this.selectedPostProcesses = selectedPostProcessResponse;
          this.capabilityDetailsForm.controls['selectedPostProcesses'].setValue(this.selectedPostProcesses)
  
          // setup industries value
          if (this.capabilities.vendor_industry_clients.length > 0) {
            for (var ele of this.capabilities.vendor_industry_clients) {
              selectedVendorIndustryResponse.push({ id: ele.id, display_name: ele.industry_name })
              self.setValueMasterClient(ele.id, ele.industry_name, ele.client_name)
            }
          }
          this.selectedVendorIndustries = selectedVendorIndustryResponse;
          this.capabilityDetailsForm.controls['selectedVendorIndustries'].setValue(this.selectedVendorIndustries)
  
          // setup certificates value
          this.capabilities.certifications.map(function (object) {
            self.setValueCertification(object)
            selectedcertificationResponse.push({ id: object.id, display_name: object.name })
          });
          this.selectedCertificates = selectedcertificationResponse;
          this.capabilityDetailsForm.controls['selectedCertificates'].setValue(this.selectedCertificates)
  
          // setup softwares
          if (this.capabilities.softwares.length != 0) {
            this.capabilities.softwares.map(function (object) {
              self.setValueVendorSoftware(object);
              selectedSoftwareIds.push(object.id)
            })
          }
  
          vendorSoftwares.map(function (object) {
            if (selectedSoftwareIds.includes(object.id)) {
              object.is_checked = true;
            }
          });
  
          // setup post processes
          if (this.capabilities.post_processes.length != 0) {
            this.capabilities.post_processes.map(function (object) {
              self.setValueVendorPostProcess(object);
              selectedPostProcessIds.push(object.id)
            })
          }
  
          vendorPostProcesses.map(function (object) {
            if (selectedPostProcessIds.includes(object.id)) {
              object.is_checked = true;
            }
          });
  
          // setup vendor works
          if (this.capabilities.wp_works.length == 0) {
            self.setValueVendorWork({ wp_name: "" });
            self.setValueVendorWork({ wp_name: "" });
          } else {
            this.capabilities.wp_works.map(function (object) {
              self.setValueVendorWork(object);
            })
          }
  
          // setup vendor quality instruments
  
          // if(res["no_of_quality_instruments"]){
          //   this.capabilityDetailsForm.controls['no_of_quality_instruments'].setValue(res["no_of_quality_instruments"])
          // }
  
  
          if (res["quality_inspection_department"] == true) {
            this.capabilityDetailsForm.controls['quality_inspection_department'].setValue(true)
            this.measuring_instrument_table = false
          } else {
            this.capabilityDetailsForm.controls['quality_inspection_department'].setValue(false)
            this.measuring_instrument_table = false
          }
  
          if (this.capabilities.vendor_quality_instruments.length == 0) {
            self.setValueQualityInstrument({ quality_instrument_name: "", brand_name: "", unit: "millimeter", quantity: "" })
          } else {
            this.capabilities.vendor_quality_instruments.map(function (object) {
              self.setValueQualityInstrument(object)
            });
          }
  
          this.loaderService.display(false);
          setTimeout(() => {
            document.getElementsByTagName('input')[0].click();
          }, 300);
        }, err => {
          this.loaderService.display(false);
          for (let i in err.error.errors) {
            this.toastr.error(err.error.errors[i]);
          }
          setTimeout(() => {
            document.getElementsByTagName('input')[0].click();
          }, 300);
        }
      );
    }
  }

  allowedFiles = ['pdf','docs','xls','pptx','jpeg','png','docx','jpg'];
  // portfolio related functions
  onCertificationDocumentSelect(event) {
    let notAllowedFiles = '';
    for (var i = 0; i < event.target.files.length; i++) {
      console.log(event.target.files[i])
      let extension = event.target.files[i]['name'].split('.');
      extension = extension[extension.length - 1].toLowerCase();
      if (this.allowedFiles.indexOf(extension) > -1) {
        this.certificationFiles.push(event.target.files[i]);
      }
      else {
        if (notAllowedFiles.length == 0) {
          notAllowedFiles = event.target.files[i]['name'];
        }
        else {
          notAllowedFiles = notAllowedFiles + ', ' + event.target.files[i]['name'];
        }
      }
    }
    if (notAllowedFiles.length > 0) {
      return this.toastr.error('This files are not allowed to upload: ' + notAllowedFiles + '.', 'Error');
    }
  }

  downloadCert(index) {
    var blob = this.certificationFiles[index]
    var url = window.URL.createObjectURL(blob)
    window.open(url)
  }


  // vendor design related function
  onchangeVendorDesignValue(values: any, item) {
    if (values.checked) {
      this.setValueVendorDesign(item)
    }
    else {
      console.log(item, values)
      this.removeVendorDesign(this.capabilityDetailsForm.value.vendor_designs_attributes.findIndex(x => x.design_id == item.id))
      console.log(this.capabilityDetailsForm.value.vendor_designs_attributes.findIndex(x => x.design_id == item.id))
      console.log(this.capabilityDetailsForm.get('vendor_designs_attributes').value)
    }
  }

  // vendor designs related functions
  setValueVendorDesign(item) {
    (this.capabilityDetailsForm.get('vendor_designs_attributes') as FormArray).push(this.fb.group({
      design_id: [item.id, Validators.required],
    }));

  }

  // removeVendorDesign
  removeVendorDesign(idx) {
    (this.capabilityDetailsForm.get('vendor_designs_attributes') as FormArray).removeAt(idx);
  }

  onChangeNoVendorDesignValue(event) {
    console.log(event)
  }



  // vendor works related functions
  addVendorWork() {
    (this.capabilityDetailsForm.get('vendor_works_attributes') as FormArray).push(this.fb.group({
      wp_name: ["", [Validators.required, Validators.minLength(3)]],
    }));
  }

  setValueVendorWork(item) {
    (this.capabilityDetailsForm.get('vendor_works_attributes') as FormArray).push(this.fb.group({
      wp_name: [item.wp_name, [Validators.required, Validators.minLength(3)]],
    }));
  }

  removeVendorWork(idx) {
    if (this.capabilityDetailsForm.get('vendor_works_attributes').value.length == 1) {
      return this.toastr.error('Please add atleast one manufacturing part', 'Error');
    }
    else {
      (this.capabilityDetailsForm.get('vendor_works_attributes') as FormArray).removeAt(idx);
    }
  }

  // vendor softwares related functions
  setValueVendorSoftware(item) {
    (this.capabilityDetailsForm.get('vendor_softwares_attributes') as FormArray).push(this.fb.group({
      software_id: [item.id, Validators.required],
      software_name: [item.name, Validators.required]
    }));

  }

  // remove vendor softwares
  removeVendorSofware(idx) {
    (this.capabilityDetailsForm.get('vendor_softwares_attributes') as FormArray).removeAt(idx);

  }

  onchangeVendorSoftwareValue(values: any, item) {

    if (values.checked) {
      if (item.id == 0) {
        this.showNewVendorSoftwareInput = true;
      } else {
        this.setValueVendorSoftware(item);

      }
    }
    else {
      if (item.id == 0) {
        this.showNewVendorSoftwareInput = false;
        this.capabilityDetailsForm.controls.new_vendor_softwares.setValue("");
      } else {
        this.removeVendorSofware(this.capabilityDetailsForm.value.vendor_softwares_attributes.findIndex(x => x.software_id == item.id))

      }
    }
  }


  get vendor_quality_instruments_attributes() {
    return (this.capabilityDetailsForm.get('vendor_quality_instruments_attributes') as FormArray);
  }

  // vendor quality instruments related functions
  addQualityInstrument() {
    (this.capabilityDetailsForm.get('vendor_quality_instruments_attributes') as FormArray).push(this.fb.group({
      quality_instrument_name: ["", [Validators.required]],
      brand_name: ["", [Validators.required]],
      size: ["", [Validators.required]],
      unit: ["millimeter", [Validators.required]],
      quantity: ["", [Validators.required, Validators.minLength(1), Validators.pattern("^[0-9]*$")]],
    }));
  }

  setValueQualityInstrument(item) {
    (this.capabilityDetailsForm.get('vendor_quality_instruments_attributes') as FormArray).push(this.fb.group({
      quality_instrument_name: [item.quality_instrument_name, [Validators.required]],
      brand_name: [item.brand_name, [Validators.required]],
      size: [item.size, [Validators.required]],
      unit: [item.unit, [Validators.required]],
      quantity: [item.quantity, [Validators.required, Validators.minLength(1), Validators.pattern("^[0-9]*$")]],
    }));
  }

  removeQualityInstrument(idx) {
    let len: any = []
    len = this.capabilityDetailsForm.get('vendor_quality_instruments_attributes')
    if (len.length == 1) {
      return this.toastr.error('Atleast 1 quality instrument is required ', 'Error')
    }
    else {
      (this.capabilityDetailsForm.get('vendor_quality_instruments_attributes') as FormArray).removeAt(idx);
    }

  }

  // vendor post process related functions
  setValueVendorPostProcess(item) {
    (this.capabilityDetailsForm.get('vendor_post_processes_attributes') as FormArray).push(this.fb.group({
      post_process_id: [item.id, Validators.required],
      name: [item.name, Validators.required]
    }));
  }

  removeVendorPostProcess(idx) {
    (this.capabilityDetailsForm.get('vendor_post_processes_attributes') as FormArray).removeAt(idx);
  }

  onchangeVendorPostProcessValue(values: any, item) {
    if (values.currentTarget.checked) {
      if (item.id == 0) {
        this.showNewVendorPostProcessInput = true;
      } else {
        this.setValueVendorPostProcess(item);
      }
    } else {
      if (item.id == 0) {
        this.showNewVendorPostProcessInput = false;
        this.capabilityDetailsForm.controls.new_post_processes.setValue("");
      } else {
        this.removeVendorPostProcess(this.capabilityDetailsForm.value.vendor_post_processes_attributes.findIndex(x => x.post_process_id == item.id))
      }
    }
  }

  // print process related functions
  onPrintProcessSelect(item: any) {
    this.setValuePrintProcess(item);
    this.selectedPrintProcesses.push({ id: item.id, display_name: item.display_name })
    console.log(this.selectedPrintProcesses)
  }

  onPrintProcessDeselect(item: any) {
    this.removePrintProcess(this.capabilityDetailsForm.value.vendor_print_processes_attributes.findIndex(x => x.id == item.id))
    let remove_index = this.selectedPrintProcesses.findIndex(x => x.id == item.id)
    if (remove_index > -1) {
      this.selectedPrintProcesses.splice(remove_index, 1)
      this.printProcesses = this.printProcesses
    }

    this.onboardingService.getPrintProcesses().subscribe(
      res => {
        this.printProcesses = res;
        this.selectedPrintProcesses = [];

      }, err => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
      }
    );

  }

  addPrintProcess() {
    (this.capabilityDetailsForm.get('vendor_print_processes_attributes') as FormArray).push(this.fb.group({
      print_process_id: ["", Validators.required],
      print_process_name: ["", Validators.required],
    }));
  }

  setValuePrintProcess(item) {
    (this.capabilityDetailsForm.get('vendor_print_processes_attributes') as FormArray).push(this.fb.group({
      print_process_id: [item.id, Validators.required],
      print_process_name: [item.display_name, Validators.required],
    }));
  }

  removePrintProcess(idx) {
    (this.capabilityDetailsForm.get('vendor_print_processes_attributes') as FormArray).removeAt(idx);
  }

  submitNewPrintProcess(newPrintName) {
    var sampleArray = this.printProcesses.splice(1, this.printProcesses.length + 1);
    var name = newPrintName;
    sampleArray.push({ id: 0, display_name: name });
    this.printProcesses = sampleArray;
    this.selectedPrintProcesses.push({ id: 0, display_name: name })
    this.capabilityDetailsForm.controls['selectedPrintProcesses'].setValue(this.selectedPrintProcesses)
    this.setValuePrintProcess({ id: 0, display_name: name });
    this.isPrintProcessAdded = true;
    console.log(this.capabilityDetailsForm.get('selectedPrintProcesses').value)
  }

  setNewPrintProcessForm() {
    this.newPrintProcessForm.reset();
    this.isPrintProcessAdded = false;
  }

  newPrintProcess() {
    const dialogRef = this.dialog.open(NewPrintProcessComponent, {
      panelClass: 'my-panel',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(
      (res: any) => {
        console.log(res.data)
        this.submitNewPrintProcess(res.data.new_print_process_name)
      }
    )
  }

  // postProcess fuctions
  // 
  // 
  onPostProcessSelect(item: any) {
    console.log(item)
    this.setValuePostProcess(item);
    this.selectedPostProcesses.push({ id: item.id, display_name: item.display_name })
    console.log(this.capabilityDetailsForm.get('vendor_post_processes_attributes').value)
  }

  onPostProcessDeselect(item: any) {
    console.log(item)
    this.removePostProcess(this.capabilityDetailsForm.value.vendor_post_processes_attributes.findIndex(x => x.post_process_id == item.id))
    let remove_index = this.selectedPostProcesses.findIndex(x => x.id == item.id)
    console.log(remove_index)
    if (remove_index > -1) {
      this.selectedPostProcesses.splice(remove_index, 1)
      this.removePostProcess(remove_index)
    }
    console.log(this.capabilityDetailsForm.get('vendor_post_processes_attributes').value)
    console.log(this.selectedPostProcesses)
  }

  setValuePostProcess(item) {
    (this.capabilityDetailsForm.get('vendor_post_processes_attributes') as FormArray).push(this.fb.group({
      post_process_id: [item.id, Validators.required],
      name: [item.display_name, Validators.required]
    }));
    (this.capabilityDetailsForm.get('vendor_post_processes_attributes'))
  }

  removePostProcess(index) {
    (this.capabilityDetailsForm.get('vendor_post_processes_attributes') as FormArray).removeAt(index);
    console.log(this.capabilityDetailsForm.get('vendor_post_processes_attributes').value)
  }

  newPostProcess() {
    const dialogRef = this.dialog.open(NewPostProcessComponent, {
      panelClass: 'my-panel',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(
      (res: any) => {
        console.log(res.data)
        this.submitNewPostProcess(res.data.new_post_process_name)
      }
    )
  }

  submitNewPostProcess(newPostName) {
    var sampleArray = this.vendorPostProcesses.splice(1, this.vendorPostProcesses.length + 1);
    var name = newPostName;
    sampleArray.push({ id: 0, display_name: name });
    this.vendorPostProcesses = sampleArray;
    this.selectedPostProcesses.push({ id: 0, display_name: name })
    this.capabilityDetailsForm.controls['selectedPostProcesses'].setValue(this.selectedPostProcesses)
    this.setValuePrintProcess({ id: 0, display_name: name });
    console.log(this.capabilityDetailsForm.get('selectedPostProcesses').value)
  }
  // 
  // 

  // machine related functions
  setManufacturingTechnologyData(manufacturingTechnology = { id: 'others', name: "others" }) {
    // this.loaderService.display(true);
    this.machineForm.reset();
    this.setMachineFields();
    this.editMachineIndex = -1;
    (this.machineForm.controls['vom_specifications'] as FormArray).clear();
    this.selectedManufacturingTechnology = manufacturingTechnology
    this.machineForm.controls['manufacturing_technology_id'].setValue(manufacturingTechnology.id)
    this.machineForm.controls['manufacturing_technology_name'].setValue(manufacturingTechnology.name)

    this.onboardingService.searchMachines(this.selectedManufacturingTechnology.id, "").subscribe(
      res => {
        this.machines = res;
      },
      err => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
      });

    if (this.selectedManufacturingTechnology.name == "Sheet Metal Manufacturing") {
      this.selectedMachine = { name: "Lasercutting", display_name: "Lasercutting" }
      this.machineForm.controls['machine_name'].setValue("Lasercutting");
    } else {
      // this.selectedMachine = { name: "Others", display_name: "Others" }
      this.addMachineSpec();
      this.machineUnits = [] || this.machineUnits;
      if (this.machineUnits.length == 0) {
        this.onboardingService.getMachineUnits().subscribe(
          res => {
            this.machineUnits = res;
            this.loaderService.display(false);
          }, err => {
            for (let i in err.error.errors) {
              this.toastr.error(err.error.errors[i]);
            }
          }
        );
      }
    }
  }

  submitMachineDetails() {
    this.machineFormSubmitted = true;
    if (this.machineForm.valid) {
      var formValue = this.machineForm.value;
      var master_spec, machine_unit, name, brandName;
      var machine_spec = [];
      if (this.selectedMachine.display_name == "Lasercutting") {
        machine_spec.push(
          { master_specification_name: "Laser Type", machine_capacity: formValue.laser_type, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Laser Power", machine_capacity: formValue.laser_power, machine_specification_unit_name: formValue.laser_power_unit },
          { master_specification_name: "Max Sheet Thickness Mild Steel", machine_capacity: formValue.max_sheet_thickness_mild_steel, machine_specification_unit_name: formValue.max_sheet_thickness_mild_steel_unit },
          { master_specification_name: "Max Sheet Thickness Stainless Steel", machine_capacity: formValue.max_sheet_thickness_stainless_steel, machine_specification_unit_name: formValue.max_sheet_thickness_stainless_steel_unit },
          { master_specification_name: "Max Sheet Thickness Aluminium", machine_capacity: formValue.max_sheet_thickness_aluminium, machine_specification_unit_name: formValue.max_sheet_thickness_aluminium_unit },
          { master_specification_name: "Max Sheet Thickness Copper", machine_capacity: formValue.max_sheet_thickness_copper, machine_specification_unit_name: formValue.max_sheet_thickness_copper_unit },
          { master_specification_name: "Max Sheet Thickness Brass", machine_capacity: formValue.max_sheet_thickness_brass, machine_specification_unit_name: formValue.max_sheet_thickness_brass_unit },
          { master_specification_name: "Working Range X", machine_capacity: formValue.working_range_x, machine_specification_unit_name: formValue.working_range_x_unit },
          { master_specification_name: "Working Range Y", machine_capacity: formValue.working_range_y, machine_specification_unit_name: formValue.working_range_y_unit },
          { master_specification_name: "Cutting Gas Oxygen", machine_capacity: formValue.cutting_gas_oxygen, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Cutting Gas Nitrogen", machine_capacity: formValue.cutting_gas_nitrogen, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Cutting Gas Compressed Air", machine_capacity: formValue.cutting_gas_compressed_air, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Marking Possible", machine_capacity: formValue.marking_possible, machine_specification_unit_name: "n/a" }
        )
      } else if (this.selectedMachine.display_name == "Punching") {
        machine_spec.push(
          { master_specification_name: "Punch Force", machine_capacity: formValue.punch_force, machine_specification_unit_name: formValue.punch_force_unit },
          { master_specification_name: "Sheet Thickness (Max)", machine_capacity: formValue.sheet_thickness, machine_specification_unit_name: formValue.sheet_thickness_unit },
          { master_specification_name: "Tool Stations", machine_capacity: formValue.tool_stations, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Tooling Diameter (Max)", machine_capacity: formValue.tooling_diameter, machine_specification_unit_name: formValue.tooling_diameter_unit },
          { master_specification_name: "No. of indexing stations", machine_capacity: formValue.no_of_indexing_stations, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Indexing diameter(Max)", machine_capacity: formValue.indexing_diameter, machine_specification_unit_name: formValue.indexing_diameter_unit },
          { master_specification_name: "Additional Process Available", machine_capacity: formValue.additional_process_available, machine_specification_unit_name: "" },
          { master_specification_name: "Forming Max Dimensions", machine_capacity: formValue.forming_max_dimensions, machine_specification_unit_name: formValue.forming_max_dimensions_unit },
          { master_specification_name: "Forming Max Height", machine_capacity: formValue.forming_max_height, machine_specification_unit_name: formValue.forming_max_height_unit },
          { master_specification_name: "Max Angle", machine_capacity: formValue.forming_max_angle, machine_specification_unit_name: formValue.forming_max_angle_unit },
          { master_specification_name: "Working Range X", machine_capacity: formValue.working_range_x, machine_specification_unit_name: formValue.working_range_x_unit },
          { master_specification_name: "Working Range Y", machine_capacity: formValue.working_range_y, machine_specification_unit_name: formValue.working_range_y_unit },
        )
      } else if (this.selectedMachine.display_name == "Combi Machines") {
        machine_spec.push(
          { master_specification_name: "Laser Type", machine_capacity: formValue.laser_type, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Laser Power", machine_capacity: formValue.laser_power, machine_specification_unit_name: formValue.laser_power_unit },
          { master_specification_name: "Max Sheet Thickness Mild Steel", machine_capacity: formValue.max_sheet_thickness_mild_steel, machine_specification_unit_name: formValue.max_sheet_thickness_mild_steel_unit },
          { master_specification_name: "Max Sheet Thickness Stainless Steel", machine_capacity: formValue.max_sheet_thickness_stainless_steel, machine_specification_unit_name: formValue.max_sheet_thickness_stainless_steel_unit },
          { master_specification_name: "Max Sheet Thickness Aluminium", machine_capacity: formValue.max_sheet_thickness_aluminium, machine_specification_unit_name: formValue.max_sheet_thickness_aluminium_unit },
          { master_specification_name: "Max Sheet Thickness Copper", machine_capacity: formValue.max_sheet_thickness_copper, machine_specification_unit_name: formValue.max_sheet_thickness_copper_unit },
          { master_specification_name: "Max Sheet Thickness Brass", machine_capacity: formValue.max_sheet_thickness_brass, machine_specification_unit_name: formValue.max_sheet_thickness_brass_unit },
          { master_specification_name: "Working Range X", machine_capacity: formValue.working_range_x, machine_specification_unit_name: formValue.working_range_x_unit },
          { master_specification_name: "Working Range Y", machine_capacity: formValue.working_range_y, machine_specification_unit_name: formValue.working_range_y_unit },
          { master_specification_name: "Cutting Gas Oxygen", machine_capacity: formValue.cutting_gas_oxygen, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Cutting Gas Nitrogen", machine_capacity: formValue.cutting_gas_nitrogen, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Cutting Gas Compressed Air", machine_capacity: formValue.cutting_gas_compressed_air, machine_specification_unit_name: "n/a" }, { master_specification_name: "Marking Possible", machine_capacity: formValue.marking_possible, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Max Sheet Thickness Punching", machine_capacity: formValue.max_sheet_thickness_punching, machine_specification_unit_name: formValue.max_sheet_thickness_punching_unit },
        )
      } else if (this.selectedMachine.display_name == "Bending") {
        machine_spec.push(
          { master_specification_name: "Bending Length (Max)", machine_capacity: formValue.bending_length, machine_specification_unit_name: formValue.bending_length_unit },
          { master_specification_name: "Free passage between pillars (Max)", machine_capacity: formValue.free_passage_between_pillars, machine_specification_unit_name: formValue.free_passage_between_pillars_unit },
          { master_specification_name: "Bending aids", machine_capacity: formValue.bending_aids, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Support brackets", machine_capacity: formValue.support_brackets, machine_specification_unit_name: "n/a" },
        )
      } else if (this.selectedMachine.display_name == "Panel Bending") {
        machine_spec.push(
          { master_specification_name: "Total number of panel benders", machine_capacity: formValue.total_number_of_panel_benders, machine_specification_unit_name: "n/a" },
        )
      } else if (this.selectedMachine.display_name == "Welding") {
        machine_spec.push(
          { master_specification_name: "Welding Type", machine_capacity: formValue.welding_type, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Max Seam Length", machine_capacity: formValue.max_seam_length, machine_specification_unit_name: formValue.max_seam_length_unit },
        )
      } else if (this.selectedMachine.display_name == "Straightening machine") {
        machine_spec.push(
          { master_specification_name: "Sheet Width (Max)", machine_capacity: formValue.max_sheet_width, machine_specification_unit_name: formValue.max_sheet_width_unit },
          { master_specification_name: "Sheet Thickness (Max)", machine_capacity: formValue.sheet_thickness, machine_specification_unit_name: formValue.sheet_thickness_unit },
          { master_specification_name: "No. of rolls", machine_capacity: formValue.no_of_rolls, machine_specification_unit_name: "n/a" },
        )
      } else if (this.selectedMachine.display_name == "De-burring machine") {
        machine_spec.push(
          { master_specification_name: "Sheet Width (Max)", machine_capacity: formValue.max_sheet_width, machine_specification_unit_name: formValue.max_sheet_width_unit },
          { master_specification_name: "Sheet Thickness (Max)", machine_capacity: formValue.sheet_thickness, machine_specification_unit_name: formValue.sheet_thickness_unit },
        )
      } else {
        formValue.vom_specifications.forEach(function (item, index) {
          master_spec = item.master_specification_name.name || item.master_specification_name;
          machine_unit = item.machine_specification_unit_name.name || item.machine_specification_unit_name;

          machine_spec.push({
            master_specification_name: master_spec,
            machine_capacity: item.machine_capacity,
            machine_specification_unit_name: machine_unit,
          })
        })
      }

      name = formValue.machine_name.name || formValue.machine_name;
      brandName = formValue.brand_name.name || formValue.brand_name;
      if (this.editMachineIndex == -1) {
        this.machineDetailsArray.push({
          vendor_machine_name: name,
          brand_name: brandName,
          model_number: formValue.model_number,
          manufacturing_technology_id: formValue.manufacturing_technology_id,
          manufacturing_technology_name: this.selectedManufacturingTechnology.name,
          number_of_machines: formValue.number_of_machines,
          spare_capacity: formValue.spare_capacity,
          machine_speciality: formValue.machine_speciality,
          is_available_for_rent: formValue.is_available_for_rent,
          address_id: formValue.address_id,
          vom_specifications: machine_spec,
          vom_attachments: formValue.vom_attachments
        })
      } else {
        this.machineDetailsArray[this.editMachineIndex] = {
          vendor_machine_name: name,
          brand_name: brandName,
          model_number: formValue.model_number,
          manufacturing_technology_id: formValue.manufacturing_technology_id,
          manufacturing_technology_name: this.selectedManufacturingTechnology.name,
          number_of_machines: formValue.number_of_machines,
          spare_capacity: formValue.spare_capacity,
          machine_speciality: formValue.machine_speciality,
          is_available_for_rent: formValue.is_available_for_rent,
          address_id: formValue.address_id,
          vom_specifications: machine_spec,
          vom_attachments: formValue.vom_attachments
        }
      }
      this.machineForm.reset();
      (this.machineForm.controls['vom_specifications'] as FormArray).clear();
      this.editMachineIndex = -1;
      $("#machineFormModal").modal('hide');
      this.machineFormSubmitted = false;
    }
  }

  saveMachineDraft() {
    if (this.machine_form_status) {
      return this.toastr.info('Please proceed to next step all your responses are saved');
    }
    else {

      let vendor_added_machines = []

      if (this.machineDetailsArray.length > 0) {
        this.machineDetailsArray.forEach(ele => {
          if (ele.vom_specifications.length > 0) {
            console.log(ele)
            vendor_added_machines.push({
              "address_id": ele.address_id,
              "address_name": ele.address_name,
              "brand_name": ele.brand_name,
              "display_name": ele.display_name,
              "id": ele.id,
              "is_available_for_rent": ele.is_available_for_rent,
              "machine_speciality": ele.machine_speciality,
              "manufacturing_technology_id": ele.manufacturing_technology_id,
              "manufacturing_technology_name": ele.manufacturing_technology_name,
              "model_number": ele.model_number,
              "number_of_machines": ele.number_of_machines,
              "spare_capacity": ele.spare_capacity,
              "vendor_machine_display_name": ele.vendor_machine_display_name,
              "vendor_machine_name": ele.vendor_machine_name,
              "vom_attachments": ele.vom_attachments,
              "vom_specifications": ele.vom_specifications
            })
          }
          else {
            return this.toastr.error('Machine details are not saved properly', 'Error');
          }
        });
      }

      let machine_details_object = {
        "new_print_processes": this.capabilityDetailsForm.get('new_print_processes').value,
        "new_certificates": this.capabilityDetailsForm.get('new_certificates').value,
        "no_of_machines": this.capabilityDetailsForm.get('no_of_machines').value,
        "selectedVendorIndustries": this.capabilityDetailsForm.get('selectedVendorIndustries').value,
        "selectedPrintProcesses": this.capabilityDetailsForm.get('selectedPrintProcesses').value,
        "selectedCertificates": this.capabilityDetailsForm.get('selectedCertificates').value,
        "selectedPostProcesses": this.capabilityDetailsForm.get('selectedPostProcesses').value,
        "vendor_designs_attributes": this.capabilityDetailsForm.get('vendor_designs_attributes').value,
        "vendor_print_processes_attributes": this.capabilityDetailsForm.get('vendor_print_processes_attributes').value,
        "vendor_industries_clients_attributes": this.capabilityDetailsForm.get('vendor_industries_clients_attributes').value,
        "vendor_certifications_attributes": this.capabilityDetailsForm.get('vendor_certifications_attributes').value,
        "vendor_owned_machines_attributes": vendor_added_machines,
        "vendor_works_attributes": this.capabilityDetailsForm.get('vendor_works_attributes').value,
        "new_vendor_softwares": this.capabilityDetailsForm.get('new_vendor_softwares').value,
        "vendor_softwares_attributes": this.capabilityDetailsForm.get('vendor_softwares_attributes').value,
        "new_post_processes": this.capabilityDetailsForm.get('new_post_processes').value,
        "vendor_post_processes_attributes": this.capabilityDetailsForm.get('vendor_post_processes_attributes').value,
        "quality_inspection_department": this.capabilityDetailsForm.get('quality_inspection_department').value,
        "vendor_quality_instruments_attributes": this.capabilityDetailsForm.get('vendor_quality_instruments_attributes').value
      }

      this.loaderService.display(true);
      this.onboardingService.postCapabilityDetails(machine_details_object).subscribe(
        res => {
          this.toastr.success("Your Capability Details saved successfully !", 'Success');
          this.loaderService.display(false);

        }, err => {
          this.loaderService.display(false);
          if (err.error.message) {
            this.toastr.error(err.error.message, 'Error');
          } else {
            for (let i in err.error.errors) {
              this.toastr.error(err.error.errors[i], 'Error');
            }
          }
        }
      );
    }

  }

  deleteFromMachineArray(idx) {
    let delete_machine = confirm("Are you sure, you want to delete the machine from the list? ")
console.log(delete_machine)
    if (delete_machine == true) {
      this.machineDetailsArray.splice(idx, 1);
      this.toastr.success('You have deleted a Machine from the added machine details', 'Success')
    }
    else{
      return
    }   
  }

  setMachineFields() {
    this.machineForm = this.fb.group({
      'machine_name': ["", Validators.required],
      'brand_name': ["", Validators.required],
      'machine_speciality': "",
      'model_number': ["", Validators.required],
      'number_of_machines': ["", Validators.required],
      'spare_capacity': ["", [Validators.required, Validators.min(0), Validators.max(100)]],
      'is_available_for_rent': ["", Validators.required],
      'address_id': ["", Validators.required],
      'manufacturing_technology_id': ["", Validators.required],
      "manufacturing_technology_name": "",
      'vom_specifications': this.fb.array([]),
      'vom_attachments': [],
      'laser_type': "",
      'laser_power': "",
      'laser_power_unit': "kW",
      'max_sheet_thickness_mild_steel': "",
      'max_sheet_thickness_stainless_steel': "",
      'max_sheet_thickness_aluminium': "",
      'max_sheet_thickness_copper': "",
      'max_sheet_thickness_brass': "",
      'max_sheet_thickness_mild_steel_unit': "mm",
      'max_sheet_thickness_stainless_steel_unit': "mm",
      'max_sheet_thickness_aluminium_unit': "mm",
      'max_sheet_thickness_copper_unit': "mm",
      'max_sheet_thickness_brass_unit': "mm",
      'working_range_x': "",
      'working_range_y': "",
      'working_range_x_unit': "mm",
      'working_range_y_unit': "mm",
      'cutting_gas_oxygen': "",
      'cutting_gas_nitrogen': "",
      'cutting_gas_compressed_air': "",
      'marking_possible': "",
      'punch_force': "",
      'punch_force_unit': "",
      'sheet_thickness': "",
      'sheet_thickness_unit': "mm",
      'tool_stations': "",
      'tooling_diameter': "mm",
      'tooling_diameter_unit': "",
      'no_of_indexing_stations': "",
      'indexing_diameter': "",
      'indexing_diameter_unit': "mm",
      'additional_process_available': "forming",
      'forming_max_dimensions': "",
      'forming_max_height': "",
      'forming_max_angle': "",
      'forming_max_dimensions_unit': "mm",
      'forming_max_height_unit': "mm",
      'forming_max_angle_unit': "Degree",
      'max_sheet_thickness_punching': "",
      'max_sheet_thickness_punching_unit': "mm",
      'bending_length': "",
      'bending_length_unit': "mm",
      'free_passage_between_pillars': "",
      'free_passage_between_pillars_unit': "mm",
      'bending_aids': "hydraulic",
      'support_brackets': "",
      'total_number_of_panel_benders': "",
      'welding_type': "",
      'max_seam_length': "",
      'max_seam_length_unit': "mm",
      'no_of_rolls': "",
      'max_sheet_width': "",
      'max_sheet_width_unit': "mm",
    })
  }

  get vendor_owned_machines_attributes() {
    return (this.capabilityDetailsForm.get('vendor_owned_machines_attributes') as FormArray);
  }

  addMachineSpec() {
    (this.machineForm.get('vom_specifications') as FormArray).push(this.fb.group({
      master_specification_name: ["", Validators.required],
      machine_capacity: ["", Validators.required],
      machine_specification_unit_name: ["", Validators.required],
    }));
  }

  setValueMachineSpec(item) {
    (this.machineForm.get('vom_specifications') as FormArray).push(this.fb.group({
      master_specification_name: [item.master_specification_name, Validators.required],
      machine_capacity: [item.machine_capacity, Validators.required],
      machine_specification_unit_name: [item.machine_specification_unit_name, Validators.required],
    }));
  }

  removeMachineSpec(idx) {
    (this.machineForm.get('vom_specifications') as FormArray).removeAt(idx);
  }


  // industry related functions
  onIndustrySelect(item: any) {
    this.setValueMasterClient(item.id, item.display_name, "");
    this.selectedVendorIndustries.push({ id: item.id, display_name: item.display_name });
  }

  onIndustryDeselect(item: any) {
    this.removeMasterClient(this.capabilityDetailsForm.value.vendor_industries_clients_attributes.findIndex(x => x.id == item.id))
    let remove_index = this.capabilityDetailsForm.value.vendor_industries_clients_attributes.findIndex(x => x.id == item.id)
    this.selectedVendorIndustries.splice(remove_index, 1)
    console.log(remove_index)
    this.onboardingService.getIndustries().subscribe(
      res => {
        this.vendorIndustries = res;
        this.selectedVendorIndustries = [];
      }, err => {
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
      }
    );
  }

  setValueMasterClient(id, industryName, ClientName) {
    (this.capabilityDetailsForm.get('vendor_industries_clients_attributes') as FormArray).push(this.fb.group({
      id: id,
      industry_name: [industryName, Validators.required],
      client_name: [ClientName, Validators.required],
    }));
  }

  removeMasterClient(idx) {
    (this.capabilityDetailsForm.get('vendor_industries_clients_attributes') as FormArray).removeAt(idx);  
  }

  submitNewIndustry(newIndustryName) {
    console.log(this.vendorIndustries)
    var sampleArray = this.vendorIndustries.splice(1, this.vendorIndustries.length + 1);
    console.log(sampleArray)
    var name = newIndustryName;
    sampleArray.push({ id: 0, name: name, display_name: name });
    this.vendorIndustries = sampleArray;
    this.selectedVendorIndustries.push({ id: 0, display_name: name });
    this.capabilityDetailsForm.controls['selectedVendorIndustries'].setValue(this.selectedVendorIndustries);
    console.log(this.capabilityDetailsForm.controls['selectedVendorIndustries'].setValue(this.selectedVendorIndustries))
    this.setValueMasterClient(0, name, "");
    this.isNewIndustryAdded = true;
  }

  setNewIndustryForm() {
    this.newIndustryForm.reset();
    this.isNewIndustryAdded = false;
  }

  newIndustry() {
    const dialogRef = this.dialog.open(NewIndustryComponent, {
      panelClass: 'my-panel',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(
      (res: any) => {        
        this.submitNewIndustry(res.data.new_industry_name)
      }
    )
  }


  // certificates related functions
  onCertificatesSelect(item: any) {
    this.setValueCertification(item);
    this.selectedCertificates.push({ id: item.id, display_name: item.display_name });
  }

  onCertificatesDeselect(item: any) {
    this.removeCertification(this.capabilityDetailsForm.value.vendor_certifications_attributes.findIndex(x => x.certification_id == item.id))
  }

  setValueCertification(item) {
    (this.capabilityDetailsForm.get('vendor_certifications_attributes') as FormArray).push(this.fb.group({
      certification_id: [item.id, Validators.required],
      certification_name: [item.display_name, Validators.required],
    }));
  }

  removeCertification(idx) {
    (this.capabilityDetailsForm.get('vendor_certifications_attributes') as FormArray).removeAt(idx);
  }

  submitNewCertificate(newCertificateName) {
    var sampleArray = this.certificates.splice(1, this.certificates.length + 1);
    var name = newCertificateName;

    sampleArray.push({ id: 0, display_name: name });
    this.certificates = sampleArray;
    this.selectedCertificates.push({ id: 0, display_name: name });
    this.capabilityDetailsForm.controls['selectedCertificates'].setValue(this.selectedCertificates);
    this.setValueCertification({ id: 0, display_name: name });
    this.isNewCertificateAdded = true;

    console.log(this.capabilityDetailsForm.get('selectedCertificates').value)
  }

  setNewCertificateForm() {
    this.newCertificateForm.reset();
    this.isNewCertificateAdded = false;
  }

  newCertificates() {
    const dialogRef = this.dialog.open(NewCertificatesComponent, {
      panelClass: 'my-panel',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(
      (res: any) => {
        console.log(res.data.new_certificate_name)
        this.submitNewCertificate(res.data.new_certificate_name)
      }
    )
  }

  submitCapabilitiesDetails() {
    let formData = new FormData();
    let name, brandName;
    let errors = [];
    console.log('this.capabilityDetailsForm', this.capabilityDetailsForm);
    console.log('this.certificationFiles', this.certificationFiles);
    this.capabilityDetailsFormSubmitted = true;

    if (this.capabilityDetailsForm.get('quality_inspection_department').value == false) {
      (this.capabilityDetailsForm.controls['vendor_quality_instruments_attributes'] as FormArray).clear();
    }

    // process onlyIf the form is valid
    if (this.capabilityDetailsForm.valid) {
      // start the loader
      this.loaderService.display(true);

      // setup the vendor designs data
      if (this.capabilityDetailsForm.get('vendor_designs_attributes').value.length > 0) {
        for (var ele of this.capabilityDetailsForm.get('vendor_designs_attributes').value) {
          formData.append('vendor_designs_attributes[][design_id]', ele.design_id)
        }
      } else {
        errors.push({ message: "Please select atleast 1 Inhouse Design capability option" })
      }

      // setup the vendor works data
      if (this.capabilityDetailsForm.get('vendor_works_attributes').value.length > 0) {
        for (var ele of this.capabilityDetailsForm.get('vendor_works_attributes').value) {
          formData.append('vendor_works_attributes[][wp_name]', ele.wp_name)
        }
      }

      // setup the vendor softwares data
      if (this.showNewVendorSoftwareInput) {
        for (var ele of this.capabilityDetailsForm.controls['new_vendor_softwares'].value) {
          if (ele.value.trim().length > 0) {
            this.setValueVendorSoftware({ "id": 0, "name": ele.value.trim() });
          }
        }
      }

      if (this.capabilityDetailsForm.get('vendor_softwares_attributes').value.length > 0) {
        for (var ele of this.capabilityDetailsForm.get('vendor_softwares_attributes').value) {
          formData.append('vendor_softwares_attributes[][software_name]', ele.software_name)
        }
      } else {
        errors.push({ message: "Please select atleast 1 Software Capability that you use in your company" })
      }

      // setup the vendor post process data
      if (this.showNewVendorPostProcessInput) {
        for (var ele of this.capabilityDetailsForm.controls['new_post_processes'].value) {
          if (ele.value.trim().length > 0) {
            this.setValueVendorPostProcess({ "id": 0, "name": ele.value.trim() });
          }
        }
      }

      // setup the new  post process value
      if (this.capabilityDetailsForm.get('vendor_post_processes_attributes').value.length > 0) {
        for (var ele of this.capabilityDetailsForm.get('vendor_post_processes_attributes').value) {
          formData.append('vendor_post_processes_attributes[][name]', ele.name)
        }
      } else {
        errors.push({ message: "Please select atleast 1 Post process that you are performing on shop floor." })
      }

      // setup the print process data
      if (this.capabilityDetailsForm.get('vendor_print_processes_attributes').value.length > 0) {
        for (var ele of this.capabilityDetailsForm.get('vendor_print_processes_attributes').value) {
          formData.append('vendor_print_processes_attributes[][print_process_name]', ele.print_process_name)
        }
      } else {
        errors.push({ message: "Please Select atleast 1 Manufacturing Process." })
      }

      // setup the vendor quality instruments data
      for (var ele of this.capabilityDetailsForm.get('vendor_quality_instruments_attributes').value) {
        name = ele.quality_instrument_name.name || ele.quality_instrument_name;
        brandName = ele.brand_name.name || ele.brand_name;

        if (name.length > 0 && brandName.length > 0) {
          formData.append('vendor_quality_instruments_attributes[][quality_instrument_name]', name)
          formData.append('vendor_quality_instruments_attributes[][brand_name]', brandName)
          formData.append('vendor_quality_instruments_attributes[][size]', ele.size || '0x0x0')
          formData.append('vendor_quality_instruments_attributes[][unit]', ele.unit || 'millimeter')
          formData.append('vendor_quality_instruments_attributes[][quantity]', ele.quantity || 1)
        }
      }

      // setup the machine data
      console.log(this.machineDetailsArray)
      let totalNumberOfMachine = 0;
      if (this.machineDetailsArray.length > 0) {
        for (var ele of this.machineDetailsArray) {
          if (ele.vom_specifications.length > 0) {
            formData.append('vendor_owned_machines_attributes[][machine_name]', ele.vendor_machine_name)
            formData.append('vendor_owned_machines_attributes[][brand_name]', ele.brand_name)
            formData.append('vendor_owned_machines_attributes[][machine_speciality]', ele.machine_speciality)
            formData.append('vendor_owned_machines_attributes[][model_number]', ele.model_number)
            formData.append('vendor_owned_machines_attributes[][spare_capacity]', ele.spare_capacity)
            formData.append('vendor_owned_machines_attributes[][number_of_machines]', ele.number_of_machines)
            if (!isNaN(ele.number_of_machines)) {
              totalNumberOfMachine = totalNumberOfMachine + Number(ele.number_of_machines);
            }
            formData.append('vendor_owned_machines_attributes[][is_available_for_rent]', ele.is_available_for_rent)
            formData.append('vendor_owned_machines_attributes[][address_id]', ele.address_id)
            formData.append('vendor_owned_machines_attributes[][manufacturing_technology_id]', ele.manufacturing_technology_id)

            if (ele.vom_attachments) {
              for (var img of ele.vom_attachments) {
                formData.append('vendor_owned_machines_attributes[][vom_attachments][][attachment_file]', img)
              }
            }


            for (var i of ele.vom_specifications) {
              formData.append('vendor_owned_machines_attributes[][vom_specifications][][master_specification_name]', i.master_specification_name)
              formData.append('vendor_owned_machines_attributes[][vom_specifications][][machine_capacity]', i.machine_capacity)
              formData.append('vendor_owned_machines_attributes[][vom_specifications][][machine_specification_unit_name]', i.machine_specification_unit_name)
            }
          } else {
            errors.push({ message: "Please add atleast 1 spec to the machine" + ele.vendor_machine_display_name })
          }

        }
      } else {
        errors.push({ message: "Please add atleast 1 machine to submit this form" })
      }

      // setup the other related data
      // formData.append('no_of_machines', this.capabilityDetailsForm.get('no_of_machines').value);
      formData.append('no_of_machines', totalNumberOfMachine.toString());
      // formData.append('no_of_quality_instruments', this.capabilityDetailsForm.get('no_of_quality_instruments').value);
      formData.append('quality_inspection_department', this.capabilityDetailsForm.get('quality_inspection_department').value);

      for (var ele of this.certificationFiles) {
        formData.append('document_files[][doc]', ele);
      }

      // setup the industries data
      if (this.capabilityDetailsForm.get('vendor_industries_clients_attributes').value.length > 0) {
        for (var ele of this.capabilityDetailsForm.get('vendor_industries_clients_attributes').value) {
          if (ele.industry_name.trim().length > 0 && ele.client_name.trim().length > 0) {
            formData.append('vendor_industries_clients_attributes[][client_name]', ele.client_name.trim())
            formData.append('vendor_industries_clients_attributes[][industry_name]', ele.industry_name.trim())
          }
        }
      } else {
        errors.push({ message: "Please Select atleast 1 Industry vertical or give us atleast one client name." })
      }

      // setup the certification data
      if (this.capabilityDetailsForm.get('vendor_certifications_attributes').value.length > 0) {
        for (var ele of this.capabilityDetailsForm.get('vendor_certifications_attributes').value) {
          formData.append('vendor_certifications_attributes[][certification_name]', ele.certification_name)
        }
      }
      else {
        errors.push({ message: "Please Select atleast 1 Certificate that you hold for the company." })
      }


      // check if any error exists
      // if yes, show them to users
      if (errors.length > 0) {
        for (var ele of errors) {
          this.toastr.error(ele.message, 'Error');
        }
        this.loaderService.display(false);
        return;
      }

      this.onboardingService.postCapabilityDetails(formData).subscribe(
        res => {
          this.toastr.success("Capability Details saved successfully!");
          this.loaderService.display(false);
          this.router.navigate(['/onboarding/terms']);

        }, err => {
          this.loaderService.display(false);
          if (err.error.message) {
            this.toastr.error(err.error.message);
          } else {
            for (let i in err.error.errors) {
              this.toastr.error(err.error.errors[i]);
            }
          }
        }
      );
    } else {
      console.log('this.capabilityDetailsForm', this.capabilityDetailsForm);
      this.toastr.error("Please fix the errors in the form.", 'Error');
      return this.capabilityDetailsForm.markAllAsTouched();
    }
  }

  onChangeMachineSearch(val: string) {
    // this.onboardingService.searchMachines(this.selectedManufacturingTechnology.id, val).subscribe(
    //   res => {
    //     this.machines = res;
    //   }, 
    //   err => {
    //     this.loaderService.display(false);
    //     for(let i in err.error.errors){
    //       this.toastr.error(err.error.errors[i]);
    //     }
    //  });
  }

  onChangeInstrumentSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    console.log(val)
    this.onboardingService.searchInstruments(val).subscribe(
      res => {
        this.instruments = res;
        console.log(this.instruments)
      },
      err => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
      });
  }

  onChangeBrandSearch(val: string) {
    this.onboardingService.searchBrands(val).subscribe(
      res => {
        this.brands = res;
      },
      err => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
      });
  }

  onMachineSelectSetSpecs(item) {
    this.loaderService.display(true);
    this.selectedMachine = item;
    if (this.selectedManufacturingTechnology.name != "Sheet Metal Manufacturing") {
      this.onboardingService.getMachineRelatedSpecs(item.id).subscribe(
        res => {
          // if(res.length > 0){
          console.log(res);
          this.masterSpecs = res;
          // }
          this.loaderService.display(false);
        },
        err => {
          this.loaderService.display(false);
          for (let i in err.error.errors) {
            this.toastr.error(err.error.errors[i]);
          }
        });
    } else {
      this.loaderService.display(false);
    }
  }

  onAvailableAddressSelect(item) {
    this.machineForm.controls['address_id'].setValue(item.id);
  }

  removeDocument(id) {
    this.loaderService.display(true);
    this.onboardingService.removeDocument(id).subscribe(
      res => {
        this.documents = res;
        this.loaderService.display(false);
      },
      err => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
      });
  }

  onVomAttachmentSelect(event) {
    if (event.target.files.length > 0) {
      this.machineForm.controls['vom_attachments'].setValue(event.target.files);
      //this.machineDetailsArray[this.editMachineIndex]['vom_attachments'] = event.target.files;
    }
  }

  onChangeQualityInpection(input) {
    if (input == false) {
      var confirmation = confirm("This action will remove all the entries for quality instruments. Please confirm to proceed!");
      console.log(confirmation)
      if (confirmation == true) {
        (this.capabilityDetailsForm.controls['vendor_quality_instruments_attributes'] as FormArray).clear();
        this.measuring_instrument_table = false;
      }
      else {
        this.capabilityDetailsForm.controls['quality_inspection_department'].setValue(true)
        this.measuring_instrument_table = false;

      }
    } else {
      this.measuring_instrument_table = true
      if (this.capabilityDetailsForm.get('vendor_quality_instruments_attributes').value.length == 0) {
        this.setValueQualityInstrument({ quality_instrument_name: "", brand_name: "", unit: "millimeter", quantity: "" })
      }
    }
  }




  // editFromMachineArray(item, idx) {
  //   this.selectedManufacturingTechnology = { name: item.manufacturing_technology_name }
  //   this.selectedMachine = { name: item.vendor_machine_name, display_name: item.vendor_machine_display_name || item.vendor_machine_name }
  //   this.editMachineIndex = idx;
  //   this.machineForm.reset()

  //   this.machineForm.controls['machine_name'].setValue(item.vendor_machine_display_name)
  //   this.machineForm.controls['brand_name'].setValue(item.brand_name)
  //   this.machineForm.controls['machine_speciality'].setValue(item.machine_speciality)
  //   this.machineForm.controls['model_number'].setValue(item.model_number)
  //   this.machineForm.controls['number_of_machines'].setValue(item.number_of_machines)
  //   this.machineForm.controls['spare_capacity'].setValue(item.spare_capacity)
  //   this.machineForm.controls['address_id'].setValue(item.address_id)
  //   this.machineForm.controls['manufacturing_technology_id'].setValue(item.manufacturing_technology_id)
  //   this.machineForm.controls['manufacturing_technology_name'].setValue(item.manufacturing_technology_name)
  //   this.machineForm.controls['is_available_for_rent'].setValue(item.is_available_for_rent)
  //   this.machineForm.controls['vom_attachments'].setValue(item.vom_attachments)

  //   if (this.selectedMachine.display_name == "Lasercutting") {
  //     item.vom_specifications.forEach(function (spec) {
  //       if (spec.master_specification_name == "Laser Type") {
  //         this.machineForm.controls['laser_type'].setValue(spec.machine_capacity)
  //       } else if (spec.master_specification_name == "Laser Power") {
  //         this.machineForm.controls['laser_power'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['laser_power_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Max Sheet Thickness Mild Steel") {
  //         this.machineForm.controls['max_sheet_thickness_mild_steel'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_sheet_thickness_mild_steel_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Max Sheet Thickness Stainless Steel") {
  //         this.machineForm.controls['max_sheet_thickness_stainless_steel'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_sheet_thickness_stainless_steel_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Max Sheet Thickness Aluminium") {
  //         this.machineForm.controls['max_sheet_thickness_aluminium'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_sheet_thickness_aluminium_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Max Sheet Thickness Copper") {
  //         this.machineForm.controls['max_sheet_thickness_copper'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_sheet_thickness_copper_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Max Sheet Thickness Brass") {
  //         this.machineForm.controls['max_sheet_thickness_brass'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_sheet_thickness_brass_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Working Range X") {
  //         this.machineForm.controls['working_range_x'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['working_range_x_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Working Range Y") {
  //         this.machineForm.controls['working_range_y'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['working_range_y_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Cutting Gas Oxygen") {
  //         this.machineForm.controls['cutting_gas_oxygen'].setValue(spec.machine_capacity)

  //       } else if (spec.master_specification_name == "Cutting Gas Nitrogen") {
  //         this.machineForm.controls['cutting_gas_nitrogen'].setValue(spec.machine_capacity)

  //       } else if (spec.master_specification_name == "Cutting Gas Compressed Air") {
  //         this.machineForm.controls['cutting_gas_compressed_air'].setValue(spec.machine_capacity)

  //       } else if (spec.master_specification_name == "Marking Possible") {
  //         this.machineForm.controls['marking_possible'].setValue(spec.machine_capacity)
  //       }
  //     }, this)

  //   } else if (this.selectedMachine.display_name == "Punching") {
  //     item.vom_specifications.forEach(function (spec) {
  //       if (spec.master_specification_name == "Punch Force") {
  //         this.machineForm.controls['punch_force'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['punch_force_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Sheet Thickness (Max)") {
  //         this.machineForm.controls['sheet_thickness'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['sheet_thickness_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Tool Stations") {
  //         this.machineForm.controls['tool_stations'].setValue(spec.machine_capacity)

  //       } else if (spec.master_specification_name == "Tooling Diameter (Max)") {
  //         this.machineForm.controls['tooling_diameter'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['tooling_diameter_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "No. of indexing stations") {
  //         this.machineForm.controls['no_of_indexing_stations'].setValue(spec.machine_capacity)

  //       } else if (spec.master_specification_name == "Indexing diameter(Max)") {
  //         this.machineForm.controls['indexing_diameter'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['indexing_diameter_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Additional Process Available") {
  //         this.machineForm.controls['additional_process_available'].setValue(spec.machine_capacity)

  //       } else if (spec.master_specification_name == "Working Range X") {
  //         this.machineForm.controls['working_range_x'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['working_range_x_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Working Range Y") {
  //         this.machineForm.controls['working_range_y'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['working_range_y_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Forming Max Dimensions") {
  //         this.machineForm.controls['forming_max_dimensions'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['forming_max_dimensions_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Forming Max Height") {
  //         this.machineForm.controls['forming_max_height'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['forming_max_height_unit'].setValue(spec.machine_specification_unit_name)
  //       }
  //       else if (spec.master_specification_name == "Max Angle") {
  //         this.machineForm.controls['forming_max_angle'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['forming_max_angle_unit'].setValue(spec.machine_specification_unit_name)
  //       }
  //     }, this)

  //   } else if (this.selectedMachine.display_name == "Combi Machines") {
  //     item.vom_specifications.forEach(function (spec) {
  //       if (spec.master_specification_name == "Laser Type") {
  //         this.machineForm.controls['laser_type'].setValue(spec.machine_capacity)
  //       } else if (spec.master_specification_name == "Laser Power") {
  //         this.machineForm.controls['laser_power'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['laser_power_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Max Sheet Thickness Mild Steel") {
  //         this.machineForm.controls['max_sheet_thickness_mild_steel'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_sheet_thickness_mild_steel_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Max Sheet Thickness Stainless Steel") {
  //         this.machineForm.controls['max_sheet_thickness_stainless_steel'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_sheet_thickness_stainless_steel_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Max Sheet Thickness Aluminium") {
  //         this.machineForm.controls['max_sheet_thickness_aluminium'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_sheet_thickness_aluminium_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Max Sheet Thickness Copper") {
  //         this.machineForm.controls['max_sheet_thickness_copper'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_sheet_thickness_copper_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Max Sheet Thickness Brass") {
  //         this.machineForm.controls['max_sheet_thickness_brass'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_sheet_thickness_brass_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Working Range X") {
  //         this.machineForm.controls['working_range_x'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['working_range_x_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Working Range Y") {
  //         this.machineForm.controls['working_range_y'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['working_range_y_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Cutting Gas Oxygen") {
  //         this.machineForm.controls['cutting_gas_oxygen'].setValue(spec.machine_capacity)

  //       } else if (spec.master_specification_name == "Cutting Gas Nitrogen") {
  //         this.machineForm.controls['cutting_gas_nitrogen'].setValue(spec.machine_capacity)

  //       } else if (spec.master_specification_name == "Cutting Gas Compressed Air") {
  //         this.machineForm.controls['cutting_gas_compressed_air'].setValue(spec.machine_capacity)

  //       } else if (spec.master_specification_name == "Marking Possible") {
  //         this.machineForm.controls['marking_possible'].setValue(spec.machine_capacity)

  //       } else if (spec.master_specification_name == "Max sheet thickness Punching") {
  //         this.machineForm.controls['max_sheet_thickness_punching'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_sheet_thickness_punching_unit'].setValue(spec.machine_specification_unit_name)
  //       }
  //     }, this)

  //   } else if (this.selectedMachine.display_name == "Bending") {
  //     item.vom_specifications.forEach(function (spec) {
  //       if (spec.master_specification_name == "Bending Length (Max)") {
  //         this.machineForm.controls['bending_length'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['bending_length_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Free passage between pillars (Max)") {
  //         this.machineForm.controls['free_passage_between_pillars'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['free_passage_between_pillars_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Bending aids") {
  //         this.machineForm.controls['bending_aids'].setValue(spec.machine_capacity)

  //       } else if (spec.master_specification_name == "Support brackets") {
  //         this.machineForm.controls['support_brackets'].setValue(spec.machine_capacity)
  //       }
  //     }, this)

  //   } else if (this.selectedMachine.display_name == "Panel Bending") {
  //     item.vom_specifications.forEach(function (spec) {
  //       if (spec.master_specification_name == "Total number of panel benders") {
  //         this.machineForm.controls['total_number_of_panel_benders'].setValue(spec.machine_capacity)
  //       }
  //     }, this)

  //   } else if (this.selectedMachine.display_name == "Welding") {
  //     item.vom_specifications.forEach(function (spec) {
  //       if (spec.master_specification_name == "Welding Type") {
  //         this.machineForm.controls['welding_type'].setValue(spec.machine_capacity)

  //       } else if (spec.master_specification_name == "Max Seam Length") {
  //         this.machineForm.controls['max_seam_length'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_seam_length_unit'].setValue(spec.machine_specification_unit_name)

  //       }
  //     }, this)

  //   } else if (this.selectedMachine.display_name == "Straightening machine") {
  //     item.vom_specifications.forEach(function (spec) {
  //       if (spec.master_specification_name == "Sheet Width (Max)") {
  //         this.machineForm.controls['max_sheet_width'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_sheet_width_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Sheet Thickness (Max)") {
  //         this.machineForm.controls['sheet_thickness'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['sheet_thickness_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "No. of rolls") {
  //         this.machineForm.controls['no_of_rolls'].setValue(spec.machine_capacity)

  //       }
  //     }, this)

  //   } else if (this.selectedMachine.display_name == "De-burring machine") {
  //     item.vom_specifications.forEach(function (spec) {
  //       if (spec.master_specification_name == "Sheet Width (Max)") {
  //         this.machineForm.controls['max_sheet_width'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['max_sheet_width_unit'].setValue(spec.machine_specification_unit_name)

  //       } else if (spec.master_specification_name == "Sheet Thickness (Max)") {
  //         this.machineForm.controls['sheet_thickness'].setValue(spec.machine_capacity)
  //         this.machineForm.controls['sheet_thickness_unit'].setValue(spec.machine_specification_unit_name)

  //       }
  //     }, this)

  //   } else {
  //     item.vom_specifications.forEach(function (spec) {
  //       this.setValueMachineSpec(spec)
  //     }, this)

  //     this.machineUnits = [] || this.machineUnits;
  //     if (this.machineUnits.length == 0) {
  //       this.onboardingService.getMachineUnits().subscribe(
  //         res => {
  //           this.machineUnits = res;
  //           this.loaderService.display(false);
  //         }, err => {
  //           for (let i in err.error.errors) {
  //             this.toastr.error(err.error.errors[i]);
  //           }
  //         }
  //       );
  //     }
  //   }

  //   $("#machineFormModal").modal('show');
  // }
}